import queryBuilder from '@glittr/frontend-core/src/plugins/validation/queryBuilder';

export default {
  ...queryBuilder.properties({
    // Validated by hand in the first step - multiple radio-buttons break validation at the moment
    // membershipTemplateId: { required: true },
  }),
};
